import React, { useState } from "react";

const ECForm = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        taluka: "",
        adhar: "",
    });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Educational Counsellor Registered Successfully (Demo Only)");
    };

    return (
        <form onSubmit={handleSubmit} className="form">
            <h3>Educational Counsellor Registration</h3>
            <input type="text" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} required />
            <input type="tel" name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange} required />
            <input type="text" name="taluka" placeholder="Taluka" value={form.taluka} onChange={handleChange} required />
            <input type="text" name="adhar" placeholder="Aadhar Number" value={form.adhar} onChange={handleChange} required />
            <button type="submit">Submit</button>
        </form>
    );
};

export default ECForm;
